import React from 'react';

function StatCard({ label, value, icon, trend, trendLabel, variant, onClick }) {
  const variantClass = variant ? ` admin-stat-card--${variant}` : '';
  return (
    <div className={`admin-stat-card${variantClass}`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div className="admin-stat-value">{value}</div>
          <div className="admin-stat-label">{label}</div>
        </div>
        {icon && <span style={{ fontSize: '20px', color: 'var(--admin-text-muted)', opacity: 0.5 }}><i className={icon} /></span>}
      </div>
      {trend !== undefined && (
        <div style={{ marginTop: '8px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ color: trend > 0 ? 'var(--admin-success)' : trend < 0 ? 'var(--admin-error)' : 'var(--admin-text-muted)' }}>
            <i className={`fa-solid fa-arrow-${trend > 0 ? 'up' : trend < 0 ? 'down' : 'right'}`} style={{ marginRight: '2px', fontSize: '10px' }} />
            {Math.abs(trend)}%
          </span>
          {trendLabel && <span style={{ color: 'var(--admin-text-muted)' }}>{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}

export default StatCard;
